import { CONTACT_NETWORK_PROFILES, CONTACT_NETWORK_TYPE, CONTROLLER_CONSTANTS, LEAD_TYPES } from '@/utils/constants';
import { appendQueryString } from '@/utils';
import {
    getContactsNetworkList,
    getContact,
    setVisualizeQualifiedContact,
    adquireContact
} from '@/services/api/contactNetwork';
import { getSubscription } from '@/services';
import { HalfCircleSpinner } from 'epic-spinners';

import ContactDetails from '@/components/supplier/contact-network/modal/contact-details';
import ConfirmationModal from '@/components/supplier/contact-network/modal/confirmation';
import ContactMixedPayment from '@/components/supplier/contact-network/modal/contact-mixed-payment';
import MultipleContactDetails from '@/components/supplier/contact-network/modal/multiple-contacts-details';
import ContactUs from '@/components/supplier/contact-network/modal/contact-us/';

import {
    capitalizeFilter,
    currencyFilter,
    monthYearFilter,
    networkContactFilter,
    cardTypeFilter,
    dateFilter,
    numberFilter,
    snakeCaseFilter,
    cnpjFilter
} from '@/utils/filters';

import { mapState, mapActions } from 'vuex';
import _ from 'lodash';

import { gmapApi } from 'vue2-google-maps';

export default {
    name: 'ContactNetwork',
    props: {
        isMobile: [Boolean, Object]
    },
    components: {
        HalfCircleSpinner,
        ContactDetails,
        ConfirmationModal,
        ContactUs,
        ContactMixedPayment,
        MultipleContactDetails
    },
    data() {
        return {
            states: [
                {
                    value: '',
                    name: 'Estado',
                    center: {
                        lat: -11.1655247,
                        lng: -55.0055765
                    }
                },
                {
                    value: 'BA',
                    name: 'Bahia',
                    center: {
                        lat: -12.9726728,
                        lng: -38.4818126
                    }
                },
                {
                    value: 'DF',
                    name: 'Distrito Federal',
                    center: {
                        lat: -15.7751267,
                        lng: -48.0778302
                    }
                },
                {
                    value: 'MG',
                    name: 'Minas Gerais',
                    center: {
                        lat: -19.9166889,
                        lng: -43.9366757
                    }
                },
                {
                    value: 'PR',
                    name: 'Paraná',
                    center: {
                        lat: -24.4374873,
                        lng: -51.8957044
                    }
                },
                {
                    value: 'RJ',
                    name: 'Rio de Janeiro',
                    center: {
                        lat: -22.910363,
                        lng: -43.1990757
                    }
                },
                {
                    value: 'RS',
                    name: 'Rio Grande do Sul',
                    center: {
                        lat: -30.0643735,
                        lng: -51.1978148
                    }
                },
                {
                    value: 'SP',
                    name: 'São Paulo',
                    center: {
                        lat: -23.5530078,
                        lng: -46.6475243
                    }
                }
            ],
            contacts: [],
            profiles: [
                { label: 'Condomínio', value: CONTACT_NETWORK_PROFILES.CONDOMINIUM, selected: false },
                { label: 'Construção civil', value: CONTACT_NETWORK_PROFILES.CIVIL_CONSTRUCTION, selected: false },
                { label: 'Fornecedor', value: CONTACT_NETWORK_PROFILES.SUPPLIER, selected: false },
                { label: 'Pessoa física', value: CONTACT_NETWORK_PROFILES.PRIVATE_PERSON, selected: false },
                { label: 'Pessoa jurídica', value: CONTACT_NETWORK_PROFILES.CORPORATIVE, selected: false },
                {
                    label: 'Síndico profissional',
                    value: CONTACT_NETWORK_PROFILES.PROFESSIONAL_BUILDING_MANAGER,
                    selected: false
                }
            ],
            selectedState: { value: '' },
            hasMoreContacts: false,
            loadMoreContactsURL: null,
            selectedContact: {
                city: '',
                contact_type: '',
                created_at: '',
                email: '',
                id: '',
                logo: '',
                name: '',
                neighborhood: '',
                phone: '',
                postal_code: '',
                profile: '',
                questions: [],
                quotations: [],
                secondary_phone: '',
                state: '',
                title: '',
                trading_name: '',
                has_balance: false,
                tags: [],
                corporative_profile: ''
            },
            selectedCity: '',
            selectedNeighborhood: '',
            contactAdquired: false,
            CONTROLLER_CONSTANTS: CONTROLLER_CONSTANTS,
            LEAD_TYPES: LEAD_TYPES,
            subscription: {
                price_per_aditional_contact: 0,
                engelink_cash: 0
            },
            markers: [],
            googleMapOptions: {
                draggable: true,
                fullscreenControl: false,
                mapTypeId: 'roadmap',
                maxZoom: 14,
                minZoom: 5,
                rotateControl: false,
                scaleControl: false,
                scrollwheel: true,
                streetViewControl: false,
                zoom: 5,
                zoomControl: true
            },
            mapCenter: {},
            defaultMapCenter: {
                lat: -11.1655247,
                lng: -55.0055765
            },
            loadingContacts: false,
            loadingMoreContacts: false,
            searchQuery: '',
            debounceFunction: () => {},
            CONTACT_NETWORK_PROFILES: CONTACT_NETWORK_PROFILES,
            cities: [],
            neighborhoods: [],
            selectedContactFilter: 'all-contacts',
            contactFilters: [
                {
                    label: 'Todos os contatos',
                    value: 'all-contacts'
                },
                {
                    label: 'Contatos Pros',
                    value: 'engelink-contacts-only'
                },
                {
                    label: 'Contatos Qualificados',
                    value: 'public-contacts-only'
                }
            ],
            CONTACT_NETWORK_TYPE: CONTACT_NETWORK_TYPE,
            adquiredContactsTotal: 0,
            contactsTotal: 0,
            disableButton: false,
            multipleContactsGrid: {
                desktopHeader: [
                    { text: '', textAlignment: 'left' },
                    { text: 'Tipo de contato', textAlignment: 'left' },
                    { text: 'Quantidade', textAlignment: 'center' },
                    { text: 'Subtotal', textAlignment: 'center' }
                ],
                mobileHeader: [
                    { text: '', textAlignment: 'left' },
                    { text: 'Tipo de contato', textAlignment: 'left' },
                    { text: 'Quantidade', textAlignment: 'center' },
                    { text: 'Subtotal', textAlignment: 'center' }
                ],
                rows: [],
                desktopColumnWidth: '',
                mobileColumnsWidth: '',
                desktopKeys: ['logo', 'label', 'amount', 'subtotal'],
                mobileKeys: ['logo', 'label', 'amount', 'subtotal']
            },
            contactVisualized: false,
            topContacts: [],
            totalOfRequests: 4,
            loadingAdditionalContacts: false,
            filtersApplied: false,
            hasFiltersBeenApplied: false,
            hasCellphoneFilter: false,
            isSendingNotification: false,
            showModal: false,
            modalSelected: false,
            modalSelectedMixedPayment: 'ContactMixedPayment',
            modalSelectedConfirmation: 'ConfirmationModal',
            showModalConfirmation: false,
            textConfirmation: '',
            typeConfirmation: '',
            showModalMixedPayment: false,
            showBanner: true,
            multipleContacts: false
        };
    },
    async created() {
        // inicia o mapa no centro
        this.mapCenter = this.defaultMapCenter;
        // gera lista de contatos inciial
        this.listContacts();
        if (this.isSupplier) {
            await this.getSubscription();
        }

        this.debounceFunction = _.debounce(() => this.filterContacts(), 1500);
    },
    mounted() {
        this.multipleContactsGrid.desktopColumnsWidth = this.getColumnsWidth();
        this.multipleContactsGrid.mobileColumnsWidth = this.getColumnsWidth();
    },
    methods: {
        ...mapActions('notification', ['showNotification']),
        ...mapActions('payment', ['setContactNetwork']),
        capitalizeFilter,
        currencyFilter,
        monthYearFilter,
        networkContactFilter,
        cardTypeFilter,
        dateFilter,
        numberFilter,
        snakeCaseFilter,
        cnpjFilter,
        getColumnsWidth() {
            return '15% 18% 33% 34%';
        },
        async filterContacts() {
            this.loadingAdditionalContacts = false;
            this.filtersApplied = false;
            let queriesStrings = '';

            if (this.selectedState && this.selectedState.value) {
                queriesStrings = appendQueryString(queriesStrings, this.getStateFilter(this.selectedState.value));
            }

            if (this.searchQuery) {
                queriesStrings = appendQueryString(queriesStrings, this.getSearchQuery(this.searchQuery));
            }

            if (this.isProContactsFilterSelected || this.isQualifiedContactsFilterSelected) {
                queriesStrings = appendQueryString(queriesStrings, this.getFilterOption(this.selectedContactFilter));
            }

            const profiles = this.profiles.filter(profile => profile.selected);
            if (profiles.length > 0) {
                queriesStrings = appendQueryString(queriesStrings, this.getProfilesFilter(profiles));
            }

            if (this.hasCellphoneFilter) {
                queriesStrings = appendQueryString(queriesStrings, this.getHasCellphoneFilter());
            }

            try {
                const contactsResponse = await getContactsNetworkList(queriesStrings);

                const contacts = contactsResponse.data.results.map(contact => {
                    contact.selected = false;
                    return contact;
                });
                this.contacts = contacts;

                this.contactsTotal = contactsResponse.data.count;
                this.hasMoreContacts = contactsResponse.data.next != null;
                this.loadMoreContactsURL = contactsResponse.data.next;
                this.loadingContacts = false;
                let temp = 0;
                this.loadingAdditionalContacts = true;
                while (!this.filtersApplied && this.isSupplier && temp < this.totalOfRequests && this.hasMoreContacts) {
                    await this.loadAdditionalContacts();
                    temp++;
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.loadingContacts = false;
                this.loadingAdditionalContacts = false;
            }
        },
        getStateFilter(value) {
            return `state=${value}`;
        },
        getCityFilter(value) {
            return `city=${value}`;
        },
        getNeighborhoodFilter(value) {
            return `neighborhood=${value}`;
        },
        getSearchQuery(value) {
            return `search=${value}`;
        },
        getFilterOption(value) {
            if (value === this.contactFilters[1].value) {
                return 'pro_contacts_only=true';
            } else if (value === this.contactFilters[2].value) {
                return 'qualified_contacts_only=true';
            }
            return '';
        },
        getProfilesFilter(profiles) {
            profiles = profiles.map(profile => profile.value);
            return `contact_type=${profiles.join('&contact_type=')}`;
        },
        getHasCellphoneFilter() {
            return 'has_cellphone=true';
        },
        async getSubscription() {
            this.subscription = {};
            try {
                const { data, error } = await getSubscription();
                if (!error) {
                    this.subscription = data;
                }
            } catch (e) {
                console.log(e);
            }
        },
        applyFilters() {
            this.filtersApplied = true;
            this.hasFiltersBeenApplied = true;
            this.loadingContacts = true;
            this.debounceFunction();
        },
        async loadMoreContacts() {
            if (this.loadingAdditionalContacts) {
                return;
            }

            try {
                this.loadingMoreContacts = true;
                this.loadingAdditionalContacts = true;

                const queriesParams = `?${this.loadMoreContactsURL.split('?')[1]}`;

                const contactsResponse = await getContactsNetworkList(queriesParams);
                const contacts = contactsResponse.data.results.map(contact => {
                    contact.selected = false;
                    return contact;
                });
                this.contacts = this.contacts.concat(contacts);
                this.hasMoreContacts = contactsResponse.data.next != null && contacts.length > 0;
                this.loadMoreContactsURL = contactsResponse.data.next;
                this.loadingMoreContacts = false;
                let temp = 0;
                while (this.isSupplier && temp < this.totalOfRequests && this.hasMoreContacts) {
                    await this.loadAdditionalContacts();
                    temp++;
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.filtersApplied = false;
                this.loadingMoreContacts = false;
                this.loadingAdditionalContacts = false;
            }
        },
        async loadAdditionalContacts() {
            if (!this.loadingAdditionalContacts || this.filtersApplied) {
                return;
            }

            try {
                const queriesParams = `?${this.loadMoreContactsURL.split('?')[1]}`;

                const contactsResponse = await getContactsNetworkList(queriesParams);
                const contacts = contactsResponse.data.results.map(contact => {
                    contact.selected = false;
                    return contact;
                });
                this.contacts = this.contacts.concat(contacts);
                this.hasMoreContacts = contactsResponse.data.next != null && contacts.length > 0;
                this.loadMoreContactsURL = contactsResponse.data.next;
            } catch (error) {
                console.error(error);
            }
        },
        async listContacts() {
            this.loadingContacts = true;
            try {
                const contactsResponse = await getContactsNetworkList('');

                const contacts = contactsResponse.data.results.map(contact => {
                    contact.selected = false;
                    return contact;
                });
                this.contacts = contacts;

                this.contactsTotal = contactsResponse.data.count;
                this.hasMoreContacts = contactsResponse.data.next != null;
                this.loadMoreContactsURL = contactsResponse.data.next;
                this.loadingContacts = false;
                let temp = 0;
                this.loadingAdditionalContacts = true;
                while (!this.filtersApplied && this.isSupplier && temp < this.totalOfRequests && this.hasMoreContacts) {
                    await this.loadAdditionalContacts();
                    temp++;
                }
            } catch (error) {
                console.error(error);
                this.loadingContacts = false;
            } finally {
                this.loadingAdditionalContacts = false;
            }
        },
        filterSelectedContacts(contacts) {
            const profiles = [
                { label: 'Condomínio', value: CONTACT_NETWORK_PROFILES.CONDOMINIUM, amount: 0, subtotal: '0' },
                {
                    label: 'Construção civil',
                    value: CONTACT_NETWORK_PROFILES.CIVIL_CONSTRUCTION,
                    amount: 0,
                    subtotal: '0'
                },
                { label: 'Fornecedor', value: CONTACT_NETWORK_PROFILES.SUPPLIER, amount: 0, subtotal: '0' },
                { label: 'Pessoa física', value: CONTACT_NETWORK_PROFILES.PRIVATE_PERSON, amount: 0, subtotal: '0' },
                { label: 'Pessoa jurídica', value: CONTACT_NETWORK_PROFILES.CORPORATIVE, amount: 0, subtotal: '0' },
                {
                    label: 'Síndico profissional',
                    value: CONTACT_NETWORK_PROFILES.PROFESSIONAL_BUILDING_MANAGER,
                    amount: 0,
                    subtotal: '0'
                }
            ];

            for (const profile of profiles) {
                const items = contacts.filter(contact => contact.contactType === profile.value);
                if (items.length) {
                    profile.amount = items.length;
                    profile.subtotal = items.reduce((accumulator, contact) => accumulator + contact.finalPrice, 0);
                }
            }

            return profiles.filter(profile => profile.amount > 0);
        },
        selectAllContacts() {
            this.contacts.map(contact => {
                contact.selected = true;
                return contact;
            });
        },
        unselectAllContacts() {
            this.contacts.map(contact => {
                contact.selected = false;
                return contact;
            });
        },
        toggleContactSelect(contactId) {
            const contact = this.contacts.find(contact => contact.id === contactId);
            if (contact) {
                contact.selected = !contact.selected;
            }
        },
        openMultipleAquisitionModal() {
            if (this.isDefaultSubscription) {
                this.modalSelectedConfirmation = 'eg-default-subscription-modal';
                this.showModalConfirmation = true;
            } else {
                if (this.isSupplier) {
                    if (!this.subscription.contactNetwork) {
                        this.showNotification({
                            text:
                                'Sua assinatura não possibilita acesso ao Leads Prediais. Para habilitar esse acesso em sua assinatura nos envie uma solicitação.',
                            type: 'info'
                        });
                    } else if (
                        this.isProContactsFilterSelected &&
                        !this.subscription.canPurchaseProContacts &&
                        this.subscription.freeProContactsBalance <= 0
                    ) {
                        this.showNotification({ text: 'Você não pode mais adquirir contatos Pros.', type: 'info' });
                    } else if (
                        this.isProContactsFilterSelected &&
                        this.hasMoreProContactsSelectedThanFreeBalance &&
                        !this.subscription.canPurchaseProContacts &&
                        this.subscription.freeProContactsBalance > 0
                    ) {
                        this.showNotification({
                            text:
                                'Você não pode comprar contatos Pros e você selecionou mais créditos de contatos Pros do que você pode adquirir.',
                            type: 'info'
                        });
                    } else if (
                        this.isQualifiedContactsFilterSelected &&
                        !this.subscription.canPurchaseQualifiedContacts &&
                        this.subscription.freeQualifiedContactsBalance <= 0
                    ) {
                        this.showNotification({
                            text: 'Você não pode mais adquirir contatos Qualificados.',
                            type: 'info'
                        });
                    } else if (
                        this.isQualifiedContactsFilterSelected &&
                        this.hasMoreQualifiedContactsSelectedThanFreeBalance &&
                        !this.subscription.canPurchaseQualifiedContacts &&
                        this.subscription.freeQualifiedContactsBalance > 0
                    ) {
                        this.showNotification({
                            text:
                                'Você não pode comprar contatos Qualificados e você selecionou mais créditos de contatos Qualificados do que você pode adquirir.',
                            type: 'info'
                        });
                    } else {
                        if (
                            !this.hasMoreContactsSelectedThanBalance &&
                            !this.hasMoreProContactsSelectedThanFreeBalance &&
                            !this.hasMoreQualifiedContactsSelectedThanFreeBalance
                        ) {
                            //  esse é o modal de detalhes de multiplos contatos
                            this.modalSelected = 'MultipleContactDetails';
                            this.showModal = true;
                        } else {
                            if (this.hasMoreQualifiedContactsSelectedThanFreeBalance) {
                                this.showNotification({
                                    text: ' Você selecionou mais contatos Qualificados do que você pode adquirir.',
                                    type: 'info'
                                });
                            } else if (this.hasMoreProContactsSelectedThanFreeBalance) {
                                this.showNotification({
                                    text: 'Você selecionou mais contatos Pros do que você pode adquirir.',
                                    type: 'info'
                                });
                            } else if (this.hasMoreProContactsSelectedThanBalance) {
                                this.showNotification({
                                    text: 'Você selecionou mais contatos Pros do que você pode adquirir.',
                                    type: 'info'
                                });
                            } else if (this.hasMoreQualifiedContactsSelectedThanBalance) {
                                this.showNotification({
                                    text: 'Você selecionou mais contatos Qualificados do que você pode adquirir.',
                                    type: 'info'
                                });
                            } else if (this.hasMoreCondoContactsSelectedThanBalance) {
                                this.showNotification({
                                    text: 'Você selecionou mais contatos de condomínio do que você pode adquirir.',
                                    type: 'info'
                                });
                            } else if (this.hasMoreCorporativeContactsSelectedThanBalance) {
                                this.showNotification({
                                    text: 'Você selecionou mais contatos de pessoa jurídica do que você pode adquirir.',
                                    type: 'info'
                                });
                            } else if (this.hasMoreBuildingManagerContactsSelectedThanBalance) {
                                this.showNotification({
                                    text:
                                        'Você selecionou mais contatos de síndico profissional do que você pode adquirir.',
                                    type: 'info'
                                });
                            } else if (this.hasMoreSupplierContactsSelectedThanBalance) {
                                this.showNotification({
                                    text: 'Você selecionou mais contatos de fornecedor do que você pode adquirir.',
                                    type: 'info'
                                });
                            } else if (this.hasMoreCivilConstructionContactsSelectedThanBalance) {
                                this.showNotification({
                                    text:
                                        'Você selecionou mais contatos de construção civil do que você pode adquirir.',
                                    type: 'info'
                                });
                            } else if (this.hasMorePrivatePersonContactsSelectedThanBalance) {
                                this.showNotification({
                                    text: 'Você selecionou mais contatos de pessoa física do que você pode adquirir.',
                                    type: 'info'
                                });
                            } else if (this.hasMoreBasicContactsSelectedThanBalance) {
                                this.showNotification({
                                    text: 'Você selecionou mais contatos básicos do que você pode adquirir.',
                                    type: 'info'
                                });
                            }
                        }
                    }
                }
            }
        },
        async openContactModal(contactId) {
            // openContactModal
            if (this.isSupplier && !this.subscription.contactNetwork) {
                this.modalSelectedConfirmation = 'ContactUs';
                this.showModalConfirmation = true;
            } else if (this.isDefaultSubscription) {
                this.modalSelectedConfirmation = 'eg-default-subscription-modal';
                this.showModalConfirmation = true;
            } else {
                this.resetSelectedContact();
                await this.retrieveContact(contactId);
            }
        },
        resetSelectedContact() {
            this.selectedContact = {
                city: '',
                contact_type: '',
                created_at: '',
                email: '',
                id: '',
                logo: '',
                name: '',
                neighborhood: '',
                phone: '',
                postal_code: '',
                profile: '',
                questions: [],
                quotations: [],
                secondary_phone: '',
                state: '',
                title: '',
                trading_name: '',
                has_balance: false,
                tags: [],
                corporative_profile: ''
            };
        },
        async retrieveContact(contactId) {
            this.contactAdquired = false;

            try {
                const contactResponse = await getContact(contactId);

                if (contactResponse.data.immobile && contactResponse.data.immobile.particulars) {
                    let particulars = contactResponse.data.immobile.particulars.replace('{', '');
                    particulars = particulars.replace('}', '');
                    contactResponse.data.immobile.particulars = particulars.replace(',', ', ');
                }
                _.merge(this.selectedContact, contactResponse.data);
                const tags = [...new Set(contactResponse.data.tags.map(tag => tag.name))];
                this.$set(this.selectedContact, 'tags', tags);

                if (
                    this.isSupplier &&
                    this.selectedContact.cardType === CONTACT_NETWORK_TYPE.PRO_CONTACT &&
                    !this.subscription.canPurchaseProContacts &&
                    this.subscription.freeProContactsBalance <= 0
                ) {
                    this.showNotification({ text: 'Você não pode mais adquirir contatos Pros.', type: 'info' });
                } else if (
                    this.isSupplier &&
                    this.selectedContact.cardType === CONTACT_NETWORK_TYPE.QUALIFIED_CONTACT &&
                    !this.subscription.canPurchaseQualifiedContacts &&
                    this.subscription.freeQualifiedContactsBalance <= 0
                ) {
                    this.showNotification({ text: 'Você não pode mais adquirir contatos Qualificados.', type: 'info' });
                } else {
                    if (
                        this.isSupplier &&
                        this.subscription.infiniteQualifiedContactVisualization &&
                        this.selectedContact.cardType === CONTACT_NETWORK_TYPE.QUALIFIED_CONTACT
                    ) {
                        await this.visualizeQualifiedContact(this.selectedContact.id);
                    }
                    // abrir o modal de detalhes
                    this.modalSelected = 'ContactDetails';
                    this.showModal = true;
                }
            } catch (error) {
                console.error(error);
            }
        },
        async visualizeQualifiedContact(contactId) {
            try {
                this.disableButton = true;
                const data = {
                    contact_id: contactId
                };
                const adquireMultiplePublicContactsResponse = await setVisualizeQualifiedContact(data);
                this.contactVisualized = true;
                _.merge(this.selectedContact, adquireMultiplePublicContactsResponse.data);
                this.disableButton = false;
            } catch (error) {
                console.error(error);
                this.disableButton = false;
            }
        },
        openProCreditPaymentModal() {
            this.multipleContacts = false;
            // abrir os modais com essa confirmação
            this.textConfirmation = 'Deseja adquirir esse contato com crédito?';
            this.typeConfirmation = LEAD_TYPES.CONTACT_FREE;
            this.modalSelectedConfirmation = 'ConfirmationModal';
            this.showModalConfirmation = true;
        },
        openMixedPaymentModal() {
            // modal de pagamento misto
            this.modalSelectedMixedPayment = 'ContactMixedPayment';
            this.showModalMixedPayment = true;
        },
        openQualifiedCreditPaymentModal() {
            this.multipleContacts = false;
            // abrir os modais com essa confirmação
            this.textConfirmation = 'Deseja adquirir esse contato com crédito?';
            this.typeConfirmation = LEAD_TYPES.CONTACT_FREE;
            this.modalSelectedConfirmation = 'ConfirmationModal';
            this.showModalConfirmation = true;
        },
        openBonusPaymentModal() {
            this.multipleContacts = false;
            // abrir os modais com essa confirmação
            this.textConfirmation = 'Deseja adquirir esse contato com bônus?';
            this.typeConfirmation = LEAD_TYPES.CONTACT_BONUS;
            this.modalSelectedConfirmation = 'ConfirmationModal';
            this.showModalConfirmation = true;
        },
        openEngelinkCashPaymentModal() {
            // abrir os modais com essa confirmação
            this.multipleContacts = false;
            this.textConfirmation = 'Deseja adquirir esse contato com moedas?';
            this.typeConfirmation = LEAD_TYPES.CONTACT_ENGELINK_CASH;
            this.modalSelectedConfirmation = 'ConfirmationModal';
            this.showModalConfirmation = true;
        },
        openMultipleContactsCreditPaymentModal() {
            // aqui é o problema o metodo de retorno deve ser o  adquireSelectedContacts não o adquireSingleContact
            this.multipleContacts = true;
            this.textConfirmation = 'Deseja adquirir esses contatos com crédito?';
            this.typeConfirmation = LEAD_TYPES.CONTACT_FREE;
            this.modalSelectedConfirmation = 'ConfirmationModal';
            this.showModalConfirmation = true;
        },
        openMultipleContactsBonusPaymentModal() {
            this.multipleContacts = false;
            this.textConfirmation = 'Deseja adquirir esses contatos com bônus?';
            this.typeConfirmation = LEAD_TYPES.CONTACT_BONUS;
            this.modalSelectedConfirmation = 'ConfirmationModal';
            this.showModalConfirmation = true;
        },
        openMultipleContactsEngelinkCashPaymentModal() {
            this.multipleContacts = false;
            this.textConfirmation = 'Deseja adquirir esses contatos com moedas?';
            this.typeConfirmation = LEAD_TYPES.CONTACT_ENGELINK_CASH;
            this.modalSelectedConfirmation = 'ConfirmationModal';
            this.showModalConfirmation = true;
        },
        adquireSingleContact(leadType) {
            const contacts = [this.selectedContact.id];
            const multipleContacts = false;
            this.adquireContacts(contacts, leadType, multipleContacts);
        },
        confirmationPositive(leadType) {
            this.adquireSingleContact(leadType);
        },
        confirmationPositiveMultiple(leadType) {
            this.adquireSelectedContacts(leadType);
        },
        adquireSelectedContacts(leadType) {
            if (!this.subscription.contactNetwork) {
                this.showNotification({
                    text:
                        'Sua assinatura não possibilita acesso ao Leads Prediais. Para habilitar esse acesso em sua assinatura nos envie uma solicitação.',
                    type: 'info'
                });
            } else {
                let contacts = this.contacts.filter(contact => contact.selected);
                contacts = contacts.map(contact => contact.id);
                const multipleContacts = true;
                this.adquireContacts(contacts, leadType, multipleContacts);
            }
        },
        async adquireContacts(contacts, leadType, multipleContacts = false) {
            try {
                if (leadType !== LEAD_TYPES.CONTACT_CREDIT_CARD) {
                    this.disableButton = true;
                    const data = {
                        contacts: contacts,
                        payment_type: leadType
                    };
                    const contactResponse = await adquireContact(data);

                    if (contacts.length === 1 && !multipleContacts) {
                        _.merge(this.selectedContact, contactResponse.data);
                        const tags = [...new Set(contactResponse.data.tags.map(tag => tag.name))];
                        this.$set(this.selectedContact, 'tags', tags);
                        this.contactAdquired = true;
                        this.showNotification({ text: 'Contato adquirido com sucesso.', type: 'success' });
                    } else {
                        this.showNotification({ text: 'Contatos adquiridos com sucesso.', type: 'success' });
                    }

                    this.showModal = false;
                    this.showModalConfirmation = false;
                    this.showModalMixedPayment = false;

                    this.contacts = this.contacts.filter(contact => this.contacts.indexOf(contact.id) !== -1);
                    this.contactsTotal -= contacts.length;
                    this.unselectAllContacts();
                    this.disableButton = false;
                    this.debounceFunction();
                    await this.getSubscription();
                } else {
                    this.setContactNetwork(this.selectedContact.id);
                    this.$router.push({ name: 'Checkout' });
                }
            } catch (error) {
                this.contactAdquired = false;
                console.error(error);
                this.disableButton = false;
            }
        }
    },
    computed: {
        ...mapState('user', ['user']),
        isDefaultSubscription() {
            return this.user.type.isSubscriptionDefault;
        },
        hasSubscription() {
            return this.user.type ? this.user.type.hasSubscription : false;
        },
        isSupplier() {
            return this.user.type ? this.user.type.isSupplier : false;
        },
        isSupplierValidated() {
            return this.user.type.isSupplierValidated;
        },
        isSubscriptionDefault() {
            return this.user.type.isSubscriptionDefault;
        },
        canSelectContacts() {
            return (
                this.isSupplier &&
                this.hasSubscription &&
                (this.isProContactsFilterSelected || this.isQualifiedContactsFilterSelected)
            );
        },
        isProContactsFilterSelected() {
            return this.selectedContactFilter === this.contactFilters[1].value;
        },
        isQualifiedContactsFilterSelected() {
            return this.selectedContactFilter === this.contactFilters[2].value;
        },
        disableInfiniteScroll() {
            return this.loadingMoreContacts || !this.isSupplier || !this.hasMoreContacts;
        },
        selectedContacts() {
            const selectedContacts = this.contacts.filter(contact => contact.selected);
            return selectedContacts;
        },
        selectedContactsTotal() {
            const selectedContacts = this.selectedContacts;
            return selectedContacts.length;
        },
        selectedContactsTotalPrice() {
            let freeContactsBalance = 0;
            if (this.isProContactsFilterSelected) {
                freeContactsBalance = this.subscription.freeProContactsBalance;
            } else if (this.isQualifiedContactsFilterSelected) {
                freeContactsBalance = this.subscription.freeQualifiedContactsBalance;
            }

            const contacts = this.selectedContacts.map((contact, index) => {
                if (index < freeContactsBalance) {
                    contact.finalPrice = 0;
                }
                return contact;
            });
            return contacts.reduce((accumulator, contact) => accumulator + contact.finalPrice, 0);
        },
        selectedContactsProfiles() {
            let freeContactsBalance = 0;
            if (this.isProContactsFilterSelected) {
                freeContactsBalance = this.subscription.freeProContactsBalance;
            } else if (this.isQualifiedContactsFilterSelected) {
                freeContactsBalance = this.subscription.freeQualifiedContactsBalance;
            }

            const contacts = this.selectedContacts.map((contact, index) => {
                if (index < freeContactsBalance) {
                    contact.finalPrice = 0;
                }
                return contact;
            });
            return this.filterSelectedContacts(contacts);
        },
        selectedContactsSubtotal() {
            const subtotal = this.selectedContactsProfiles.reduce(
                (accumulator, contacts) => accumulator + contacts.subtotal,
                0
            );
            return subtotal;
        },
        selectedProContacts() {
            return this.contacts.filter(
                contact => contact.selected && contact.cardType === CONTACT_NETWORK_TYPE.PRO_CONTACT
            );
        },
        selectedQualifiedContacts() {
            return this.contacts.filter(
                contact => contact.selected && contact.cardType === CONTACT_NETWORK_TYPE.QUALIFIED_CONTACT
            );
        },
        selectedCondoContacts() {
            return this.contacts.filter(
                contact => contact.selected && contact.contactType === CONTACT_NETWORK_PROFILES.CONDOMINIUM
            );
        },
        selectedCorporativeContacts() {
            return this.contacts.filter(
                contact => contact.selected && contact.contactType === CONTACT_NETWORK_PROFILES.CORPORATIVE
            );
        },
        selectedBuildingManagerContacts() {
            return this.contacts.filter(
                contact =>
                    contact.selected && contact.contactType === CONTACT_NETWORK_PROFILES.PROFESSIONAL_BUILDING_MANAGER
            );
        },
        selectedPrivatePersonContacts() {
            return this.contacts.filter(
                contact => contact.selected && contact.contactType === CONTACT_NETWORK_PROFILES.PRIVATE_PERSON
            );
        },
        selectedCivilConstructionContacts() {
            return this.contacts.filter(
                contact => contact.selected && contact.contactType === CONTACT_NETWORK_PROFILES.CIVIL_CONSTRUCTION
            );
        },
        selectedSupplierContacts() {
            return this.contacts.filter(
                contact => contact.selected && contact.contactType === CONTACT_NETWORK_PROFILES.SUPPLIER
            );
        },
        selectedBasicContacts() {
            return this.contacts.filter(
                contact => contact.selected && contact.contactType === CONTACT_NETWORK_PROFILES.BASIC
            );
        },
        hasSubtotalBalance() {
            return this.subscriptionEngelinkCash > 0 && this.subscriptionEngelinkCash >= this.selectedContactsSubtotal;
        },
        hasSubtotalBonus() {
            return this.subscriptionBonusCash > 0 && this.subscriptionBonusCash >= this.selectedContactsSubtotal;
        },
        hasSubtotalMixedPayment() {
            return (
                this.subscriptionBonusCash > 0 &&
                this.subscriptionEngelinkCash > 0 &&
                this.subscriptionBonusCash + this.subscriptionEngelinkCash >= this.selectedContactsSubtotal
            );
        },
        hasMoreProContactsSelectedThanBalance() {
            return (
                this.isProContactsFilterSelected &&
                this.subscription.proContactsBalance < this.selectedProContacts.length
            );
        },
        hasMoreQualifiedContactsSelectedThanBalance() {
            return (
                this.isQualifiedContactsFilterSelected &&
                this.subscription.qualifiedContactsBalance < this.selectedQualifiedContacts.length
            );
        },
        hasMoreProContactsSelectedThanFreeBalance() {
            return (
                this.isProContactsFilterSelected &&
                this.subscription.freeProContactsBalance < this.selectedProContacts.length
            );
        },
        hasMoreQualifiedContactsSelectedThanFreeBalance() {
            return (
                this.isQualifiedContactsFilterSelected &&
                this.subscription.freeQualifiedContactsBalance < this.selectedQualifiedContacts.length
            );
        },
        hasMoreCondoContactsSelectedThanBalance() {
            if (this.isProContactsFilterSelected) {
                return this.subscription.condoProContactsBalance < this.selectedCondoContacts.length;
            } else if (this.isQualifiedContactsFilterSelected) {
                return this.subscription.condoQualifiedContactsBalance < this.selectedCondoContacts.length;
            } else {
                return false;
            }
        },
        hasMoreCorporativeContactsSelectedThanBalance() {
            if (this.isProContactsFilterSelected) {
                return this.subscription.corporativeQualifiedContactsBalance < this.selectedCorporativeContacts.length;
            } else if (this.isQualifiedContactsFilterSelected) {
                return this.subscription.corporativeQualifiedContactsBalance < this.selectedCorporativeContacts.length;
            } else {
                return false;
            }
        },
        hasMoreBuildingManagerContactsSelectedThanBalance() {
            if (this.isProContactsFilterSelected) {
                return (
                    this.subscription.buildingManagerProContactsBalance < this.selectedBuildingManagerContacts.length
                );
            } else if (this.isQualifiedContactsFilterSelected) {
                return (
                    this.subscription.buildingManagerQualifiedContactsBalance <
                    this.selectedBuildingManagerContacts.length
                );
            } else {
                return false;
            }
        },
        hasMoreBasicContactsSelectedThanBalance() {
            if (this.isProContactsFilterSelected) {
                return (
                    this.subscription.buildingManagerProContactsBalance < this.selectedBuildingManagerContacts.length
                );
            } else if (this.isQualifiedContactsFilterSelected) {
                return (
                    this.subscription.buildingManagerQualifiedContactsBalance <
                    this.selectedBuildingManagerContacts.length
                );
            } else {
                return false;
            }
        },
        hasMoreCivilConstructionContactsSelectedThanBalance() {
            if (this.isProContactsFilterSelected) {
                return (
                    this.subscription.civilConstructionProContactsBalance <
                    this.selectedCivilConstructionContacts.length
                );
            } else if (this.isQualifiedContactsFilterSelected) {
                return (
                    this.subscription.civilConstructionQualifiedContactsBalance <
                    this.selectedCivilConstructionContacts.length
                );
            } else {
                return false;
            }
        },
        hasMorePrivatePersonContactsSelectedThanBalance() {
            if (this.isProContactsFilterSelected) {
                return this.subscription.privatePersonProContactsBalance < this.selectedPrivatePersonContacts.length;
            } else if (this.isQualifiedContactsFilterSelected) {
                return (
                    this.subscription.privatePersonQualifiedContactsBalance < this.selectedPrivatePersonContacts.length
                );
            } else {
                return false;
            }
        },
        hasMoreSupplierContactsSelectedThanBalance() {
            if (this.isProContactsFilterSelected) {
                return this.subscription.supplierProContactsBalance < this.selectedSupplierContacts.length;
            } else if (this.isQualifiedContactsFilterSelected) {
                return this.subscription.supplierQualifiedContactsBalance < this.selectedSupplierContacts.length;
            } else {
                return false;
            }
        },
        hasMoreContactsSelectedThanBalance() {
            return (
                this.hasMoreProContactsSelectedThanBalance ||
                this.hasMoreQualifiedContactsSelectedThanBalance ||
                this.hasMoreCondoContactsSelectedThanBalance ||
                this.hasMoreCorporativeContactsSelectedThanBalance ||
                this.hasMoreBuildingManagerContactsSelectedThanBalance ||
                this.hasMoreBasicContactsSelectedThanBalance ||
                this.hasMoreCivilConstructionContactsSelectedThanBalance ||
                this.hasMorePrivatePersonContactsSelectedThanBalance ||
                this.hasMoreSupplierContactsSelectedThanBalance
            );
        },
        subscriptionBonusCash() {
            if (this.subscription) {
                return parseFloat(this.subscription.bonusCash ? this.subscription.bonusCash : 0);
            } else {
                return 0;
            }
        },
        subscriptionEngelinkCash() {
            if (this.subscription) {
                return parseFloat(this.subscription.engelinkCash);
            } else {
                return 0;
            }
        },
        google: gmapApi
    },
    watch: {
        selectedState() {
            if (this.selectedState.center) {
                this.mapCenter = this.selectedState.center;
            } else {
                this.mapCenter = this.defaultMapCenter;
                this.$refs.googleMaps.$mapPromise.then(map => {
                    map.setZoom(this.googleMapOptions.minZoom);
                });
            }
            this.selectedCity = '';
            this.selectedNeighborhood = '';
        },
        selectedCity(value) {
            this.selectedNeighborhood = '';
        },
        contacts(value) {
            const markers = this.contacts.filter(
                contact => parseFloat(contact.latitude) !== 0 && parseFloat(contact.longitude) !== 0
            );
            this.markers = markers.map(contact => {
                return {
                    lat: parseFloat(contact.latitude),
                    lng: parseFloat(contact.longitude)
                };
            });

            if (this.markers.length > 0) {
                const google = this.google;
                if (google) {
                    const bounds = new google.maps.LatLngBounds();
                    if (this.contacts.length > 0) {
                        for (const marker of this.markers) {
                            bounds.extend(marker);
                        }
                    } else {
                        bounds.extend(this.defaultMapCenter);
                        this.$refs.googleMaps.$mapPromise.then(map => {
                            map.setZoom(this.googleMapOptions.minZoom);
                        });
                    }
                    this.$refs.googleMaps.fitBounds(bounds);
                }
            }
        },
        selectedContactFilter() {
            this.unselectAllContacts();
        },
        selectedContacts() {
            this.multipleContactsGrid.rows = this.selectedContactsProfiles;
        }
    }
};
